/**
 * Initialize FCM early (before login)
 * This ensures token is available when user logs in
 */
import { initializeFCM, getFCMToken } from '../services/fcmService';
import firebaseApp, { VAPID_KEY } from '../config/firebase';
import axios from 'axios';
import baseURL from './baseURL';

let fcmInitialized = false;

export const initializeFCMEarly = async () => {
    // Only initialize once
    if (fcmInitialized) {
        console.log('⏭️ FCM already initialized');
        return;
    }

    try {
        console.log('🔔 Early FCM initialization (before login)...');
        
        // Initialize Firebase Messaging
        const messaging = await initializeFCM(firebaseApp);
        
        if (messaging) {
            // Get FCM token
            const token = await getFCMToken(VAPID_KEY);
            
            if (token) {
                console.log('✅ FCM token ready for login:', token.substring(0, 20) + '...');
                fcmInitialized = true;
                return token;
            } else {
                console.warn('⚠️ FCM initialized but no token obtained');
            }
        } else {
            console.warn('⚠️ FCM initialization failed or permission denied');
        }
    } catch (error) {
        console.error('❌ Error initializing FCM early:', error);
    }
    
    return null;
};

/**
 * Sync FCM token to Doctor/Patient model after login.
 * The login API saves the token to the User model, but chat notifications
 * look up the token from the Doctor/Patient model. This ensures both are in sync.
 */
export const syncFCMTokenToProfile = async () => {
    try {
        const fcmToken = localStorage.getItem('fcmToken');
        const userId = localStorage.getItem('ID');
        const role = localStorage.getItem('Role');
        const accessToken = localStorage.getItem('accessToken');

        if (!fcmToken || !userId || !role || !accessToken) return;

        const headers = { Authorization: `Bearer ${accessToken}` };

        if (role === 'doctor') {
            await axios.patch(`${baseURL}/doctors/${userId}`, { fcmToken }, { headers });
            console.log('FCM token synced to Doctor model');
        } else if (role === 'patient') {
            await axios.put(`${baseURL}/patients/${userId}`, { fcmToken }, { headers });
            console.log('FCM token synced to Patient model');
        }
    } catch (error) {
        console.error('Error syncing FCM token to profile:', error.message);
    }
};

export const isFCMInitialized = () => fcmInitialized;

